export const CHANGE_SELECTED_PROCESS = 'CHANGE_SELECTED_PROCESS'
export const CHANGE_SELECTED_PROCESS_DONE = 'CHANGE_SELECTED_PROCESS_DONE'
